<template>
  <div class="card" v-if="carregando">
    <div class="card-body">
      <div class="text-center">
        <b-spinner class="ms-2" variant="primary"></b-spinner>
      </div>
    </div>
  </div>

  <div class="card" v-else>
    <div class="card-body table-responsive">
      <b-table
        class="datatables"
        responsive="sm"
        bordered
        striped
        show-empty
        :fields="colunas"
        :items="dados"
        :per-page="itensPorPagina"
        :current-page="currentPage"
        :foot-clone="footClone"
      >

        <template v-for="celula in celulasCustomizadas" v-slot:[`cell(${celula.key})`]="data">
          <slot :name="`cell(${celula.key})`" v-bind="data" />
        </template>

        <template v-for="celulaFooter in celulasCustoizadasFooter" v-slot:[`foot(${celulaFooter.key})`]="data">
          <slot :name="`foot(${celulaFooter.key})`" v-bind="data" />
        </template>

        <template #empty>
          <div class="text-center text-muted">Nenhum dado encontrado.</div>
        </template>

      </b-table>

      <b-pagination
        v-model="currentPage"
        :total-rows="dados.length"
        :per-page="itensPorPagina"
        align="right"
        class="pagination pagination-rounded mb-0"
      />

    </div>
  </div>
</template>

<script>
export default {
  props: {
    colunas       : { type: Array  , required: true },  /* Colunas da grid, Ex: { key: "exemplo", label: "EXEMPLO", sortable: true },          */
    dados         : { type: Array  , required: true },  /* Dados da grid, Ex: { exemplo: "Exemplo de dado da grid"}                            */
    carregando    : { type: Boolean, default: false },  /* true = Mostra div com o spiner | false = Mostra a grid                              */
    footClone     : { type: Boolean, default: false },  /* true = Clona o header da grid e permite customiza-lo, Ex: <template #foot(exemplo)> */
    itensPorPagina: { type: Number , default: 10 },     /* Quantidade de itens que será mostrado por página                                    */
  },
  data() {
    return {
      currentPage: 1,
    };
  },
  computed: {
    celulasCustomizadas() {
      return this.colunas.filter(field => this.$scopedSlots[`cell(${field.key})`]);
    },
    celulasCustoizadasFooter() {
      return this.colunas.filter(field => this.$scopedSlots[`foot(${field.key})`]);
    }
  }
};
</script>

<style scoped>
.sortable-header {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.sort-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 5px;
}
</style>